// extracted by mini-css-extract-plugin
export var orderSummary = "_mq-0";
export var showMoreLessButton = "_mq-1";